import { render, staticRenderFns } from "./PartnerBalance.vue?vue&type=template&id=15b0664e&scoped=true"
import script from "./PartnerBalance.vue?vue&type=script&lang=js"
export * from "./PartnerBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0664e",
  null
  
)

export default component.exports